import { DotLegalEmptyState, DotLegalPaper, ITableHeader } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import useLegalEntitySystemTabHooks from "./LegalEntitySystemTab.hooks";
import { useTranslation } from "../../localization/useTranslation";
import { LegalEntitySystemTableModel } from "./LegalEntitySystemTab.types";
import { Box, TableCell, TableRow } from "@mui/material";
import SystemIcon from "../../system/systemIcon/SystemIcon";
import EmptyState from "../../common/svgs/emptyStates/emptyState_1.svg?react";
import DotLegalLink from "../../common/components/dotLegalLink/DotLegalLink";
import { useUrlProvider } from "../../useUrlProvider";
import DotLegalTableWithFilterBar from "@common/components/dotLegalTableWithFilterBar/DotLegalTableWithFilterBar";

export interface ILegalEntityAssetsTab {
    legalEntityId: string;
}

function LegalEntitySystemTab(props: ILegalEntityAssetsTab) {
    const { systems, isLoading, hasData, getFilterOptions, onFilterChange, pinnedFilterIds, onPinnedFilterIdsChange, hasActiveFilters } =
        useLegalEntitySystemTabHooks(props);
    const { translateString } = useTranslation();
    const { getSystemOverviewUrl } = useUrlProvider();

    function getHeaders() {
        const headers = Array<ITableHeader<LegalEntitySystemTableModel>>();
        headers.push({ property: "icon", text: "", align: "left", showOnMobile: true });
        headers.push({ property: "name", text: translateString("asset"), align: "left", showOnMobile: true });
        headers.push({ property: "roles", text: translateString("role"), align: "left", showOnMobile: true });
        return headers;
    }

    return (
        <React.Fragment>
            <DotLegalPaper>
                <React.Fragment>
                    {hasData ? (
                        <DotLegalTableWithFilterBar
                            headers={getHeaders()}
                            defaultOrderBy={"name"}
                            clickableRows={false}
                            data={systems}
                            isLoading={isLoading}
                            defaultOrder={"asc"}
                            rowsPerPage={30}
                            hidePagination
                            filterBar={{
                                isLoading: isLoading,
                                filterData: getFilterOptions(),
                                fetchFilterData: true,
                                onMenuClose: onFilterChange,
                                onRemove: onFilterChange,
                                pinnedFilterIds: pinnedFilterIds,
                                onPinnedFilterIdsChange: onPinnedFilterIdsChange,
                            }}
                            emptyText={translateString(hasActiveFilters ? "noDataMatchingCriteria" : "noData")}
                            renderRow={(row, i) => (
                                <TableRow key={row.id}>
                                    <TableCell width={75}>
                                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                            <SystemIcon systemName={row.name} size="small" />
                                        </Box>
                                    </TableCell>
                                    <TableCell>
                                        <Box key={row.id} component={"span"} sx={{ fontWeight: "bold" }}>
                                            <DotLegalLink linkColor={"primary"} to={getSystemOverviewUrl(row.id)}>
                                                {row.name}
                                            </DotLegalLink>
                                        </Box>
                                    </TableCell>
                                    <TableCell>{row.roles}</TableCell>
                                </TableRow>
                            )}
                            paginationLabelOf={""}
                        ></DotLegalTableWithFilterBar>
                    ) : (
                        <DotLegalEmptyState icon={<EmptyState />} text={translateString("legalEntityAssetsEmptyState")} />
                    )}
                </React.Fragment>
            </DotLegalPaper>
        </React.Fragment>
    );
}

export default LegalEntitySystemTab;
